import { createContext, useContext, type ReactNode } from 'react';

const EntityGridTileStatusContext = createContext<ReactNode>(null);

/**
 * Provides the tile's status mark (e.g. the validation warning) to the card layout,
 * which renders it in its title row via {@link useEntityGridTileStatus}.
 */
export function EntityGridTileStatusProvider({
  status,
  children
}: {
  status: ReactNode;
  children: ReactNode;
}) {
  return (
    <EntityGridTileStatusContext.Provider value={status}>
      {children}
    </EntityGridTileStatusContext.Provider>
  );
}

export function useEntityGridTileStatus() {
  return useContext(EntityGridTileStatusContext);
}
